import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { icon, marker } from 'leaflet';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseListComponent } from '../../shared/base-list/base-list.component';
import { NodeCreateComponent } from '../node-create/node-create.component';
import { NodeLogComponent } from '../node-log/node-log.component';


@Component({
  selector: 'app-node-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./node-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class NodeListComponent extends BaseListComponent implements OnInit {
  @Input() child_id: number;
  constructor(public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entity = 'node';
    this.form = NodeCreateComponent;
    this.limit = null;
  }

  getBody(): any {
    const body = super.getBody();
    body['child_id'] = this.child_id;
    return body;
  }

  async perform(action, row) {
    return new Promise(async (resolve, reject) => {
      try {
        switch (action.name) {
          case 'CHOOSE':
            const detail = this.activeModal.open(NodeLogComponent, { size: 'xl' });
            detail.componentInstance.id = row.id;
            detail.componentInstance.title = row.name;
            detail.componentInstance.node_data = row.data;
            break;
          default:
            await super.perform(action, row);
            resolve(true);
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  getMarker(i) {
    const size = 20 + Math.sqrt(i.children_count * 10 || 0);
    const markr = marker([i.latitude || 35.783644, i.longitude || 51.440329], {
      title: i.name,
      riseOnHover: true,
      icon: icon({
        iconUrl: `assets/images/leaflet/${i.types || 'marker'}_${i.status}.png`,
        iconSize: [size, size]
      })
    });
    markr.bindPopup(`<a href="http://${i.ip}" target="_blank">${i.name}</a>`);
    return markr;
  }
}
